var _effectorFileName = "/builds/gmini/front-ui-kit/src/ResizableColumns/utils/expand.ts";
import { convertPxToPc, convertPcToPx } from './convert';
import { correctWidths } from './correct-widths';
export function expandColumn({
  idx,
  widthsPc,
  containerW,
  foldedWidthPx
}) {
  const widthsPcItems = widthsPc.map((widthPc, idx) => ({
    widthPc,
    idx
  })); // Находим все не свернутые элементы
  // Разворачиваем текущую панель
  // Считаем количество развернутых элементов в итоге
  // Выставляем ширину пропорционально для всех элементов

  const nextWidths = [...widthsPc];
  const expandedItems = widthsPcItems.filter(item => isExpanded({
    containerW,
    foldedWidthPx,
    widthPc: item.widthPc
  }) || idx === item.idx);
  const foldedItems = widthsPcItems.filter(item => !isExpanded({
    containerW,
    foldedWidthPx,
    widthPc: item.widthPc
  }) && idx !== item.idx);
  const expandedWidthSum = 100 - foldedItems.length;
  const expandedPerColumn = expandedWidthSum / expandedItems.length;
  expandedItems.forEach(({
    idx
  }) => {
    nextWidths[idx] = expandedPerColumn;
  });
  return correctWidths({
    containerW,
    foldedWidthPx,
    widthsPc: nextWidths
  });
}
export function isExpanded({
  containerW,
  foldedWidthPx,
  widthPc
}) {
  const panelWidthPx = convertPcToPx(widthPc, containerW);
  return panelWidthPx - 1 > foldedWidthPx;
}
export function canFoldColumn({
  widthsPc,
  foldedWidthPx,
  containerW
}) {
  const foldedWidthPc = convertPxToPc(foldedWidthPx, containerW);
  const foldedCount = widthsPc.filter(w => w <= foldedWidthPc).length;
  return foldedCount < widthsPc.length - 1;
}
export function foldColumn({
  idx,
  widthsPc,
  containerW,
  foldedWidthPx
}) {
  const foldedWidthPc = convertPxToPc(foldedWidthPx, containerW);
  const widthsPcItems = widthsPc.map((widthPc, idx) => ({
    widthPc,
    idx
  })); // Сначала считаем необходимую дельту для сворачивания колонки
  // Находим все развернутые колонки
  // Сворачиваем текущую колонку на минимальную ширину
  // Увеличиваем пропорционально все развернутые колонки

  const currItem = widthsPcItems[idx];
  const currItemDelta = currItem.widthPc - foldedWidthPc;
  const expandedItems = widthsPcItems.filter(item => item.widthPc > foldedWidthPc && idx !== item.idx);
  const nextWidths = [...widthsPc];
  nextWidths[idx] = foldedWidthPc;
  expandedItems.forEach(({
    idx,
    widthPc
  }) => {
    nextWidths[idx] = widthPc + currItemDelta / expandedItems.length;
  });
  return correctWidths({
    containerW,
    foldedWidthPx,
    widthsPc: nextWidths
  });
}